<template>
  <div>
    <!-- 搜索部分 激活奖励-->
    <el-form :inline="true" :model="enquiryForm" class="demo-form-inline" label-width="80px">
      <el-form-item label="机构">
        <el-input placeholder="请选择" v-model="enquiryForm.organiza" size="medium" :disabled="true">
          <el-button slot="append" @click="mechanismSearch(1)">选择</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="运营中心">
        <el-input placeholder="请选择" v-model="enquiryForm.opera_center" size="medium" :disabled="true">
          <el-button slot="append" @click="mechanismSearch(2)">选择</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="代理商">
        <el-input placeholder="请选择" v-model="enquiryForm.agent" size="medium" :disabled="true">
          <el-button slot="append" @click="mechanismSearch(3)">选择</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="顶级代理商">
        <el-input placeholder="请选择" v-model="enquiryForm.top_agent" size="medium" :disabled="true">
          <el-button slot="append" @click="mechanismSearch(4)">选择</el-button>
        </el-input>
      </el-form-item>

      <el-form-item label="分润金额">
        <el-input size="medium" clearable v-model="enquiryForm.profit_amount" placeholder="请输入分润金额"></el-input>
      </el-form-item>
      <el-form-item label="商户号">
        <el-input size="medium" clearable v-model="enquiryForm.merchant_code" placeholder="请输入商户号"></el-input>
      </el-form-item>
      <el-form-item label="终端号">
        <el-input size="medium" clearable v-model="enquiryForm.device_code" placeholder="请输入终端号"></el-input>
      </el-form-item>
      <!-- <el-form-item label="分润类型">
        <el-select v-model="enquiryForm.profit_type" placeholder="请选择分润类型" clearable filterable>
          <el-option
              v-for="item in profit_type_options"
              :label="item.label"
              :value="item.value" :key="item">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="交易时间" style="width: 590px">
        <el-date-picker v-model="enquiryForm.trade_time" type="datetimerange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
                        @change="pickerChange">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="分润日期" style="width: 590px">
        <el-date-picker v-model="enquiryForm.profit_time" type="datetimerange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
                        @change="pickerChange2">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch(enquiryForm)">查询</el-button>
      <el-button size="medium"  style="font-size: 12px;" @click="Reset(enquiryForm)">重置</el-button>
      <el-button size="medium" type="warning" style="font-size: 12px;" @click="exportData()">导出</el-button>
      <el-button size="medium" type="danger" style="font-size: 12px;" @click="printEvent()"> 打印</el-button>
      <span style="margin-left: 10px;font-weight: 700;color: #666666">
        分润金额共计:<span style="color: red;margin: 0px 5px;">{{profitAmountSum}}</span>元
      </span>
    </div>
    <!--表格部分-->
    <el-table
        :data="tableData"
        style="width: 100%"
        :default-sort="{prop: 'date', order: 'descending'}"
        v-loading="loading"
        border
        id="tableDataId"
        size="mini"
    >
      <el-table-column
          header-align="center"
          align="center"
          prop="id"
          label="ID"
          sortable>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="user_name"
          label="盟友名称">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="device_code"
          label="终端号">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="merchant_code"
          label="商户号">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="trade_time"
          label="交易时间">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="trade_amount"
          label="交易金额">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="pay_type"
          label="刷卡类型">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="profit_time"
          label="分润时间">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="profit_amount"
          label="分润金额">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="profit_type"
          label="分润类型">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.profit_type.value == '10'" type="success" disable-transitions>
            {{scope.row.profit_type.text}}</el-tag>
          <el-tag v-if="scope.row.profit_type.value == '20'"  disable-transitions>
            {{scope.row.profit_type.text}}</el-tag>
          <el-tag v-if="scope.row.profit_type.value == '30'" type="warning" disable-transitions>
            {{scope.row.profit_type.text}}</el-tag>
          <el-tag v-if="scope.row.profit_type.value == '40'" type="info" disable-transitions>
            {{scope.row.profit_type.text}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="remark"
          label="备注信息">
      </el-table-column>
    </el-table>
    <!-- 分页部分 -->
    <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[20,50,100,200,500,1000]"
        :page-size="page_size"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        style="text-align: right"
    ></el-pagination>

    <!--机构选择表单部分-->
    <el-dialog v-if="dialogVisible" title="配置表单" :visible.sync="dialogVisible">
      <!--    搜索部分-->
      <el-form :inline="true" :model="dialogForm" class="demo-form-inline">
        <el-form-item label="名称">
          <el-input size="medium" clearable v-model="dialogForm.user_name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input size="medium" clearable v-model="dialogForm.mobile_phone" placeholder="请输入"></el-input>
        </el-form-item>
          <el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch1(dialogForm)">搜索</el-button>
          <el-button size="medium"  style="font-size: 12px;" @click="handleSearch2(dialogForm)">重置</el-button>
      </el-form>
      <!--    表格部分-->
      <el-table height="250" :data="dialogData" style="width: 100%"
                :default-sort="{prop: 'date', order: 'descending'}" v-loading="loading1" border
                @row-click="singleElection">
        <el-table-column align="center" width="55">
          <template slot="header">
            <span style="cursor:pointer" @click="cancelClick">取消</span>
          </template>
          <template slot-scope="scope">
            <el-radio class="radio" v-model="templateSelection" :label="scope.row.id">
              {{ " " }}
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="id" label="ID" sortable>
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="user_name" label="代理商名称">
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="mobile_phone" label="代理商手机号">
        </el-table-column>
      </el-table>
      <!-- 分页部分 -->
      <el-pagination background @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
                     :page-sizes="[20,50,100,200,500,1000]" :page-size="page_size1" :total="dialogTotal"
                     layout="total, sizes, prev, pager, next, jumper" style="text-align: right"></el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
    <prints ref="prints" :tableData="tableData" :tableTh="tableTh" :tableTd="tableTd" v-show="false"></prints>
  </div>
</template>

<script>
import {export_json_to_excel} from "@/excel/Export2Excel";
import prints from '@/components/print.vue';

export default {
  name: "profitInformation",
  components: {
    prints
  },
  data() {
    return {
      // 主页面部分
      loading: false, //列表loadding
      page_size: 20, //条数
      total: 0, //总数
      profitAmountSum: 0,
      tableData: [], //表格数据
      enquiryForm: {
        organiza: "", //代理商名称
        organiza_id: '', //代理商ID
        opera_center: '',//运营中心
        opera_center_id: '',//运营中心id
        agent: '',//代理商
        agent_id: '',//代理商id
        top_agent: '',//顶级代理商
        top_agent_id: '',//顶级代理商id

        profit_amount: '',//分润金额
        merchant_code: "", //商户号
        device_code: '',//终端号
        profit_type: '20',//分润类型
        profit_type_text: '',
        trade_time: '',
        start_trade_time: '',//交易起始时间
        end_trade_time: '',//交易结束时间
        profit_time: '',
        start_profit_time: '',//分润起始日期
        end_profit_time: '',//分润结束日期
        page: 1,
        page_size: 20,
      },
      // 表单部分
      loading1: false, //列表loadding
      page_size1: 20, //表单条数
      dialogTotal: 0, //表单总数
      dialogData: [], //表单数据
      dialogVisible: false, //表单页面显示
      dialogCodeVisible: false, //邀请码表单页面显示
      dialogForm: { //表单搜索数据
        page_size: 20,
        mobile_phone: "", //手机号码
        page: 1,
        user_name: "", //用户名称
      },
      //   当前选择的行的id
      templateSelection: "",
      //   当前选择的行的数据
      checkList: [],
      tableTdList: [],
      tableThList: [],
      choiceState: 0,
      //分润类型 10-交易分润、20-激活返现、30-达标奖励、40-展业奖励
      profit_type_options: [{
        label: '交易分润',
        value: '10'
      }, {
        label: '激活返现',
        value: '20'
      }, {
        label: '达标奖励',
        value: '30'
      }, {
        label: '展业奖励',
        value: '40'
      }],
      //打印
      tableTh: null,
      tableTd: null,
    }
  },
  created() {
    this.getData(this.enquiryForm);
    this.tableTh = ['ID', '代理商名称', '终端号', '商户号', '交易时间', '交易金额', '刷卡类型',
      '分润时间', '分润金额', '分润类型', '备注信息'];
    this.tableTd = ['id', 'user_name', 'device_code', 'merchant_code', 'trade_time', 'trade_amount', 'pay_type',
      'profit_time', 'profit_amount', 'profit_type_text', 'remark'];
    this.$nextTick(() => {
      this.$refs.prints.prints();
    })
  },
  methods: {
    // 机构选择页面显示（表单显示）
    mechanismSearch(can) {
      this.dialogVisible = true;
      this.getDialogData(this.dialogForm, can);
    },
    //表单获取数据
    getDialogData(params, can) { //初始化数据
      this.choiceState = can;
      let url = '';
      if (can == 1) {
        url = "/api/agent/getUserOrganiza?page=" + params.page
      } else if (can == 2) {
        url = "/api/agent/getUserOperaCenter?page=" + params.page
      } else if (can == 3) {
        url = "/api/agent/getUserAgent?page=" + params.page
      } else if (can == 4) {
        url = "/api/agent/getUserAgent?page=" + params.page
      }
      this.loading1 = true;
      this.$api.post(url, params, res => {
        if (res.status == 200) {
          let dialogData = res.data;
          this.dialogTotal = dialogData.total; //总数
          this.dialogData = dialogData.list;
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading1 = false;
      })
    },
    // 主页面部分
    //搜索
    handleSearch(searchForm) {
      searchForm.page = 1;
      this.getData(searchForm);
    },
    //重置
    Reset(searchForm) {
      searchForm.organiza = "";//代理商名称
      searchForm.organiza_id = '';//代理商ID
      searchForm.opera_center = '';//运营中心
      searchForm.opera_center_id = '';//运营中心id
      searchForm.agent = '';//代理商
      searchForm.agent_id = '';//代理商id
      searchForm.top_agent = '';//顶级代理商
      searchForm.top_agent_id = '';//顶级代理商id

      searchForm.profit_amount = '';//分润金额
      searchForm.merchant_code = "";//商户号
      searchForm.device_code = '';//终端号
      searchForm.profit_type = '';//分润类型
      searchForm.trade_time = "";
      searchForm.profit_time = "";
      this.enquiryForm.start_trade_time = '';//交易起始时间
      this.enquiryForm.end_trade_time = '';//交易结束时间
      this.enquiryForm.start_profit_time = '';//分润起始日期
      this.enquiryForm.end_profit_time = '';//分润结束日期
      this.getData(searchForm);
    },
    //分页
    handleCurrentChange(page) { //当前选中页
      this.enquiryForm.page = page;
      this.getData(this.enquiryForm);
    },
    handleSizeChange(limit) { //条数
      this.enquiryForm.page_size = limit;
      this.enquiryForm.page = 1;
      this.getData(this.enquiryForm);
    },
    pickerChange(DateArr) { //时间选择器
      this.enquiryForm.start_trade_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
      this.enquiryForm.end_trade_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
    },
    pickerChange2(DateArr) { //时间选择器
      this.enquiryForm.start_profit_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
      this.enquiryForm.end_profit_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
    },
    //获取数据
    getData(params) { //初始化数据
      this.loading = true;
      this.$api.post("/api/user_profits/profitsInfo?page=" + params.page, params, res => {
        if (res.status == 200) {
          let tableData = res.data;
          this.profitAmountSum = tableData.sum;
          this.total = tableData.total; //总数
          this.tableData = tableData.list;
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading = false;
      })
    },
    // 导出
    exportData() {
      let th = ['ID', '代理商名称', '终端号', '商户号', '交易时间', '交易金额', '刷卡类型',
        '分润时间', '分润金额', '分润类型', '备注信息'];
      let excelData = ['id', 'user_name', 'device_code', 'merchant_code', 'trade_time', 'trade_amount', 'pay_type',
        'profit_time', 'profit_amount', 'profit_type_text', 'remark'];
      this.tableData.forEach(item => { //分润类型转换文本
        item.profit_type_text = item.profit_type.text;
      });
      let data = this.formatJson(excelData, this.tableData);
      let defaultTitle = '导出文件';
      export_json_to_excel(th, data, defaultTitle)
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    //打印
    printEvent() {
      this.tableData.forEach(item => { //分润类型转换文本
        item.profit_type_text = item.profit_type.text;
      });
      this.$nextTick(() => {
        this.$refs.prints.prints();
        this.$refs.prints.print();
      })
    },
    //表单分页
    handleCurrentChange1(page) { //当前选中页
      this.dialogForm.page = page;
      this.getDialogData(this.dialogForm, this.choiceState);
    },
    handleSizeChange1(limit) { //表单条数
      this.dialogForm.page_size = limit;
      this.dialogForm.page = 1;
      this.getDialogData(this.dialogForm, this.choiceState);
    },
    //获取每行
    singleElection(row) {
      this.templateSelection = row.id;
      this.checkList = row;
      // this.checkList = this.dialogData.filter((item) => item.id === row.id)
    },
    // 表单确定
    submitForm() {
      if (this.choiceState == 1) {
        this.enquiryForm.organiza = this.checkList.user_name;
        this.enquiryForm.organiza_id = this.checkList.id;
      } else if (this.choiceState == 2) {
        this.enquiryForm.opera_center = this.checkList.user_name;
        this.enquiryForm.opera_center_id = this.checkList.id;
      } else if (this.choiceState == 3) {
        this.enquiryForm.agent = this.checkList.user_name;
        this.enquiryForm.agent_id = this.checkList.id;
      } else if (this.choiceState == 4) {
        this.enquiryForm.top_agent = this.checkList.user_name;
        this.enquiryForm.top_agent_id = this.checkList.id;
      }
      this.handleSearch2(this.dialogForm);
      this.cancelClick();
      this.dialogVisible = false;
      this.getData(this.enquiryForm);
    },
    //表单搜索
    handleSearch1(dialogForm) {
      dialogForm.page = 1;
      this.getDialogData(dialogForm, this.choiceState);
    },
    //表单重置
    handleSearch2(dialogForm) {
      dialogForm.page = 1;
      dialogForm.mobile_phone = '';
      dialogForm.user_name = '';
      this.getDialogData(dialogForm, this.choiceState);
    },
    //表单取消
    cancelDialog() {
      this.handleSearch2(this.dialogForm);
      this.cancelClick();
      this.dialogVisible = false;
    },
    //取消
    cancelClick() {
      this.checkList = [];
      this.templateSelection = '';
    },
  },
}
</script>

<style scoped>
.search-label {
  margin-left: 20px;
  padding-right: 18px;
  font-size: 14px;
  font-weight: 700;
  color: #666;
  white-space: nowrap;
}
/deep/ .el-date-editor--datetimerange{
  height: 36px;
  width: 510px;
}
</style>